import React, { useState, useEffect, useRef } from "react";
import Footer from "components/Footers/Footer.js";
import IndexNavbar from "components/Navbars/IndexNavbar";
import newbg from "assets/img/newbg.jpg";
import abtbg from "assets/img/abtbg.jpg";
import abt1 from "assets/img/abt1.png";
import abt2 from "assets/img/abt2.png";
import abt3 from "assets/img/abt3.png";
import abt4 from "assets/img/abt4.jpg";
import abt5 from "assets/img/abt5.jpg";
import abt6 from "assets/img/abt6.jpg";
import abt7 from "assets/img/abt7.jpg";
import founder from "assets/img/founder.png";
import abtimg from "assets/img/abtimg.jpg";
import newimg from "assets/img/newimg.png";
import bg1 from "assets/img/bg1.jpg";

export default function Aboutt() {
  const [activeTab, setActiveTab] = useState("mission");

  return (
    <section className="poppins">
      <IndexNavbar />

      <section className="xl:pt-0 lg:pt-0 md:pt-24 pt-20">
        <div
          className="relative xl:h-400 lg:h-300 md:h-240 h-200-px"
          style={{
            backgroundImage: `url(${abtbg})`,
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
          }}
        >
          {/* Black Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            }}
          ></div>

          <div style={{ position: "relative", zIndex: 1 }}>
            <div className="xl:gap-0">
              <div className="xl:pt-32 lg:pt-24 md:pt-20 pt-16">
                <h1 className="xl:text-7xl lg:text-5xl md:text-4xl text-4xl text-center text-white uppercase font-bold fade-item-1">
                  About
                </h1>

                <div>
                  <div className="flex items-center justify-center bg-[#FDF5E6] rounded-lg xl:mt-6 lg:mt-4 mt-2">
                    <div
                      className="xl:w-2/12 lg:w-2/12 md:w-2/12 py-2 px-2 flex items-center gap-2 justify-center "
                      style={{ border: "1px dashed white" }}
                    >
                      <span className="text-white xl:text-lg lg:text-lg font-semibold">
                        <a href="/homepage1">Home</a>
                      </span>
                      <span className="text-white font-semibold"> »</span>
                      <span className="text-white xl:text-lg lg:text-lg font-semibold">
                        About
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className=" xl:pt-20 lg:pt-16 md:pt-16 pt-12 headerbg1  ">
        <div className="container mx-auto xl:px-0 px-4 ">
          <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1  gap-4 ">
            <div className="flex items-center">
              <div>
                <h1 className="text-lg uppercase text-blue font-semibold  ">
                  About Founder
                </h1>
                <h1 className="xl:text-5xl lg:text-4xl md:text-3xl text-2xl  text-blackk font-semibold  xl:pt-2 pt-2">
                  Mr. P.K. Shelvaraj
                </h1>
                <p className="xl:text-lg text-base xl:pt-4 pt-2 text-para">
                  Did his Bachelor of Technology in
                  Mechanical Engineering 1986 batch from CALICUT UNIVERSITY. He
                  started his career as an engineer in the Fabrication,
                  Commissioning of 210MV Water Tube Steam Boiler. His career in
                  Middle East started in 1994 as engineer in Boiler
                  Manufacturing. In 1996 established a company in Saudi Arabia
                  for the fabrication and installation of Food Processing
                  Equipment, at a time when almost 100% of Food Processing
                  Equipment were imported from EUROPE. In 2005 established a
                  company in Bahrain for Fabrication and Installation of Food
                  Processing Tanks. In 2007 started Swedinox International Fzc
                  in Saif Zone Sharjah, U.A.E.
                </p>
              </div>
            </div>

            <div className=" ">
              <div className="">
              <div className="flex justify-end">
                <img
                  className="xl:w-10/12 rounded-md xl:mt-0 lg:mt-0 md:mt-12 mt-0"
                  src={founder}
                  alt="Founder"
                />
              </div>
              </div>

             
            </div>
          </div>
        </div>
      </section>

      <section className="headerbg1 xl:pt-16 lg:pt-16 md:pt-16 pt-12 xl:px-0 px-4"
>
        <p className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl text-blue uppercase font-bold text-center">
          our facilities
        </p>
        <div className="">
          <h1 className="xl:text-lg lg:text-lg md:text-lg text-lg md:pt-2 text-blackk  xl:pt-4 lg:pt-2 text-center xl:w-7/12 lg:w-7/12 mx-auto">
          The Facility is in a 3.25 Acre land provided by Kinfra in the following address in Kannur District in Kerala, which will be upgraded in phases.

It consists of:
          </h1>
        </div>
        

        <div className="container mx-auto grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-4 xl:mt-12 lg:mt-8  md:mt-8 mt-8">
          <div className="h-full">
            <div className="bg-white xl:p-8 lg:p-4 p-4 h-full">
              <h3 className="xl:text-xl lg:text-xl md:text-xl text-xl font-semibold text-blackk flex items-center">
              Phase 01
              </h3>
              <p className="text-para  xl:text-base lg:text-base text-base pt-2 lg:pt-2 xl:pt-8">
              1000 Sq.mtr Factory Stainless steel fabrication & integration with most modern self-sufficient machines and equipment with testing facility will be producing process plants for the Entrepreneurs.
              240 Sq.mtrs Office with state-of-the-art facility for conference & Seminars.
              </p>
              <div
                className="p-4 blue flex items-center justify-center mt-4 lg:mt-4 xl:mt-8"
                style={{
                  width: "73px",
                  height: "60px",
                  position: "relative",
                }}
              >
                <div>
                  <img src={abt1} alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="h-full">
            <div className="bg-white xl:p-8 lg:p-4 p-4 h-full">
              <h3 className="xl:text-xl lg:text-xl md:text-xl text-xl font-semibold text-blackk flex items-center">
              Phase 02
              </h3>
              <p className="text-para  xl:text-base lg:text-base text-base pt-2 lg:pt-2 xl:pt-8">
              1000 Sq.mtr Stainless steel fabrication & integration facility equipped with advanced machinery and automated systems to enhance precision and efficiency. This phase will focus on streamlining production, improving quality control, 
              </p>
              <div
                className="p-4 blue flex items-center justify-center mt-4 lg:mt-8 xl:mt-8 md:mt-8"
                style={{
                  width: "73px",
                  height: "60px",
                  position: "relative",
                }}
              >
                <div>
                  <img className="" src={abt2} alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="h-full">
            <div className="bg-white xl:p-8 lg:p-4 p-4 h-full">
              <h3 className="xl:text-xl lg:text-xl md:text-xl text-xl font-semibold text-blackk flex items-center">
              Phase 03
              </h3>
              <p className="text-para  xl:text-base lg:text-base text-base pt-2 lg:pt-2 xl:pt-8">
              Dedicated stainless steel fabrication, integration, and storage unit for finished goods. This phase will incorporate a systematic warehousing and logistics setup to ensure proper handling, packaging, and timely dispatch of finished products 
              </p>
              <div
                className="p-4 blue flex items-center justify-center mt-4 lg:mt-8 xl:mt-8 md:mt-8"
                style={{
                  width: "73px",
                  height: "60px",
                  position: "relative",
                }}
              >
                <div>
                  <img src={abt3} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="headerbg1 xl:px-0 px-4 xl:pb-16 lg:pb-16 md:pb-12 pb-12 ">
        <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1 grid-cols-1 gap-6 xl:pt-20 lg:pt-16 md:pt-16 pt-12 container mx-auto">
          {/* Left Side - Image */}
          <div className="">
            {/* {activeTab === "history" && (
              <img className="xl:w-12/12" src={abt4} alt="Our History" />
            )} */}
            {activeTab === "mission" && (
              <img className="xl:w-12/12 " src={abt4} alt="Our Mission" />
            )}
            {activeTab === "vision" && (
              <img className="xl:w-12/12 " src={abt4} alt="Our Vision" />
            )}
          </div>

          {/* Right Side - Tabs and Content */}
          <div className="xl:mt-0 lg:mt-0 md:mt-0 mt-4">
            {/* Tabs */}
            <div className="flex justify-between bg-white text-xl xl:w-7/12 lg:w-10/12 md:w-8/12">
              {/* <button
                className={`py-3 px-6 ${
                  activeTab === "history"
                    ? "text-blue bordertop font-semibold"
                    : ""
                } focus:outline-none`}
                onClick={() => setActiveTab("history")}
              >
                Our History
              </button> */}
              <button
                className={`py-3 px-6 ${
                  activeTab === "mission"
                    ? "text-blue text-xl bordertop font-semibold"
                    : ""
                } focus:outline-none`}
                onClick={() => setActiveTab("mission")}
              >
                Our Mission
              </button>
              <button
                className={`py-3 px-6 ${
                  activeTab === "vision"
                    ? "text-blue text-xl bordertop font-semibold"
                    : ""
                } focus:outline-none`}
                onClick={() => setActiveTab("vision")}
              >
                Our Vision
              </button>
            </div>

            {/* Content */}
            <div className="">
              {/* {activeTab === "history" && (
                <div>
                  <p className="text-para xl:pt-4 text-base lg:pt-4 pt-4 mr-4">
                    Welcome to Industrie, a leading industry innovator with a
                    rich history excellence. With a passion for precision and a
                    commitment to quality we have been empowering industries and
                    driving progress with construction.
                  </p>
                  <ul className="xl:mt-6 mt-4 ">
                    <li className="flex items-center gap-2 text-para">
                      <span
                        className="flex items-center justify-center borderblue text-blue  rounded-full p-2"
                        style={{ width: "25px", height: "25px" }}
                      >
                        ✔
                      </span>
                      Quality Control System
                    </li>
                    <li className="flex items-center gap-2 text-para xl:mt-6 mt-4">
                      <span
                        className="flex items-center justify-center borderblue text-blue font-bold rounded-full p-2"
                        style={{ width: "25px", height: "25px" }}
                      >
                        ✔
                      </span>
                      Building Quality Industrial
                    </li>
                    <li className="flex items-center gap-2 text-para xl:mt-6 mt-4">
                      <span
                        className="flex items-center justify-center borderblue text-blue font-bold rounded-full p-2"
                        style={{ width: "25px", height: "25px" }}
                      >
                        ✔
                      </span>
                      Quality Control System
                    </li>
                  </ul>
                  <button className="blue text-white font-semibold xl:py-3 xl:px-6 lg:px-4 lg:py-2 rounded-lg hover:bg-green-700 px-2 py-2 xl:mt-8 mt-4">
                    Get in Touch <span className="ml-2">+</span>
                  </button>
                </div>
              )} */}

              {activeTab === "mission" && (
                <div>
                  <p className="text-para xl:pt-4 text-base lg:pt-4 pt-4 mr-4">
                    To Enlighten our youth and women to show the opportunity in
                    food processing in an innovative way to design, fabricate,
                    integrate & commission process plants for entrepreneurs.
                    Provide Project turnkey solutions with waste processing to
                    support Environment and to expand the market possibilities.
                    This will help the new investment in food processing &
                    farming. Young people can stay in their hometown with their
                    family and can generate more income with pride & happiness
                    by marketing their product inside & outside the country at
                    value added price.
                  </p>
                  <ul className="xl:mt-4 mt-4 ">
                    <li className="flex items-center gap-2 text-para">
                      <span
                        className="flex items-center justify-center borderblue text-blue  rounded-full p-2"
                        style={{ width: "25px", height: "25px" }}
                      >
                        ✔
                      </span>
                      Empowering youth and women through innovative food
                      processing opportunities
                    </li>
                    <li className="flex items-center gap-2 text-para xl:mt-6 mt-4">
                      <span
                        className="flex items-center justify-center borderblue text-blue font-bold rounded-full p-2"
                        style={{ width: "25px", height: "25px" }}
                      >
                        ✔
                      </span>
                      Promoting turnkey waste processing solutions for a greener
                      environment
                    </li>
                    <li className="flex items-center gap-2 text-para xl:mt-6 mt-4">
                      <span
                        className="flex items-center justify-center borderblue text-blue font-bold rounded-full p-2"
                        style={{ width: "25px", height: "25px" }}
                      >
                        ✔
                      </span>
                      Creating local employment and value-added market
                      opportunities
                    </li>
                  </ul>
                  <a href="/contact">
                  <button className="blue text-white font-semibold xl:py-3 xl:px-6 lg:px-4 lg:py-2 rounded-lg hover:bg-green-700 px-2 py-2 xl:mt-8 mt-4">
                    Get in Touch <span className="ml-2">+</span>
                  </button>
                  </a>
                </div>
              )}

              {activeTab === "vision" && (
                <div>
                  <p className="text-para xl:pt-4 text-base lg:pt-4 pt-4 mr-4">
                    To Produce Worlds best products and to make Bharat Proud by
                    integrating small plants for Food, beverages,
                    Pharmaceuticals, as a part of Atmanirbhar Bharat. All the
                    Raw Agricultural products by our Farmers, should be
                    processed with indegenously designed process plants to avoid
                    the wastage to benefit the farmers also to produce value
                    added product from industrial & domestic food waste.
                  </p>
                  <ul className="xl:mt-4 mt-4 ">
                    <li className="flex items-center gap-2 text-para">
                      <span
                        className="flex items-center justify-center borderblue text-blue  rounded-full p-2"
                        style={{ width: "25px", height: "25px" }}
                      >
                        ✔
                      </span>
                      Integrating small plants for food, beverages, and
                      pharmaceuticals
                    </li>
                    <li className="flex items-center gap-2 text-para xl:mt-6 mt-4">
                      <span
                        className="flex items-center justify-center borderblue text-blue font-bold rounded-full p-2"
                        style={{ width: "25px", height: "25px" }}
                      >
                        ✔
                      </span>
                      Supporting Atmanirbhar Bharat through innovation
                    </li>
                    <li className="flex items-center gap-2 text-para xl:mt-6 mt-4">
                      <span
                        className="flex items-center justify-center borderblue text-blue font-bold rounded-full p-2"
                        style={{ width: "25px", height: "25px" }}
                      >
                        ✔
                      </span>
                      Processing raw agricultural products to reduce wastage
                    </li>
                  </ul>
                  <a href="/contact">
                  <button className="blue text-white font-semibold xl:py-3 xl:px-6 lg:px-4 lg:py-2 rounded-lg hover:bg-green-700 px-2 py-2 xl:mt-8 mt-4">
                    Get in Touch <span className="ml-2">+</span>
                  </button>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>


      <section className=" xl:pt-12 lg:pt-16 md:pt-16 pt-12 xl:pb-16 pb-12 " style={{
          backgroundImage: `url(${bg1})`,
          width: "100%",
          
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}>
              <div className="container mx-auto xl:px-0 px-4">
              <p className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl text-blue uppercase font-bold text-center">
         why choose us
        </p>
        <div className="">
          <h1 className="xl:text-lg lg:text-lg md:text-lg text-lg md:pt-2 text-blackk  xl:pt-4 lg:pt-2 text-center xl:w-7/12 lg:w-7/12 mx-auto">
           In managing small batch sizes and frequent product changes with short production times and automatic cleaning cycles, we provides a dependable and efficient solution for your processing needs, ensuring optimal performance across various production scenarios.


          </h1>
        </div>
                <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 xl:mt-16 lg:mt-16  md:mt-8 mt-8 gap-4 lg:gap-4  xl:gap-4">
                  <div className="xl:w-10/12 lg:w-10/12 md:w-10/12">
                    <div className="">
                      <img
                        className="xl:w-8/12 lg:w-8/12 md:w-8/12 xl:mt-0 lg:mt-0 md:mt-6 "
                        src={newimg}
                        alt="/"
                      />
                    </div>
                    
                    <div className="xl:block lg:block md:block sm:hidden hidden">
                    <div className="flex justify-end">
                      <img className="xl:w-8/12 lg:w-8/12 md:w-8/12 xl:-mt-64 lg:-mt-32 md:-mt-20 z-50" src={abtimg} alt="" />
                    </div>
                    </div>
                  </div>
      
                  <div>
                    <div>
                      <div className=" ">
                        {/* Heading */}
                        <p className="xl:text-base lg:text-base text-base text-para mb-6 xl:pt-6 lg:pt-6">
                          We are a trusted provider of advanced process technologies,
                          delivering innovative solutions that enhance efficiency,
                          quality, and sustainability across various industries.
                        </p>
      
                        <div className="mt-6">
                          {/* Item 1 */}
                          <div className="flex items-start xl:gap-4 lg:gap-2 gap-4">
                            <div
                              className="p-4 blue flex items-center justify-center "
                              style={{
                                width: "73px",
                                height: "60px",
                                position: "relative",
                              }}
                            >
                             <i className="fas fa-blender text-white text-xl"></i>
                            </div>
                            <div>
                              <h3 className="font-bold xl:text-xl lg:text-lg text-xl text-black">
                              Mixing capabilities
                              </h3>
                              <p className="text-para xl:text-base lg:text-base text-base xl:w-10/12">
                              Advanced blending technology ensures precise mixing of ingredients,  
                              maintaining consistency and quality in food production.
                              </p>
                            </div>
                          </div>
      
                          <hr className="border-blue-50 xl:mt-8 lg:mt-4 mt-4 xl:w-10/12"></hr>
      
                          {/* item 2 */}
      
                          <div className="flex items-start xl:gap-4 lg:gap-4 gap-4 xl:mt-8 mt-0  lg:mt-4  mt-4">
                            <div
                              className="p-4 blue flex items-center justify-center "
                              style={{
                                width: "70px",
                                height: "60px",
                                position: "relative",
                              }}
                            >
                              <i className="fas fa-utensils text-white text-xl"></i>
                            </div>
                            <div>
                              <h3 className="font-bold xl:text-xl lg:text-lg text-xl text-black">
                              Cooking capabilities
                              </h3>
                              <p className="text-para xl:text-base lg:text-base text-base xl:w-8/12">
                              Our advanced cooking techniques ensure precise temperature control and 
                              consistent preparation, enhancing flavor and texture in every dish.
                              </p>
                            </div>
                          </div>
      
                          <hr className="border-blue-50 xl:mt-8 lg:mt-4 mt-4 xl:w-10/12"></hr>
      
                          {/* item 3 */}
      
                          <div className="flex items-start gap-4 xl:mt-8 lg:mt-4 lg:mt-4 mt-4">
                            <div
                              className="p-4 blue flex items-center justify-center "
                              style={{
                                width: "70px",
                                height: "60px",
                                position: "relative",
                              }}
                            >
                              <i className="fas fa-snowflake text-white text-xl"></i>
                            </div>
                            <div>
                              <h3 className="font-bold xl:text-xl lg:text-lg text-xl text-black">
                              Cooling Capabilities
                              </h3>
                              <p className="text-para xl:text-base lg:text-base text-base xl:w-10/12">
                              Our advanced cooling technology ensures optimal temperature control,  
                              preserving freshness and extending the shelf life of perishable goods.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
      
                </div>
              </div>
            </section>

      {/* <section className="headerbg1 xl:px-0 px-4">
        <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-6 xl:pt-20 xl:pb-20 lg:pt-16 lg:pb-16 md:pt-16 md:pb-16 pt-12 pb-12 container mx-auto">
          <div class="group">
            <div class="image-container">
              <img
                class="xl:w-12/12 w-full zoom-effectt"
                src={abt5}
                alt="Penelopa Miller"
              />
            </div>

            <div class="flex justify-center">
              <div class="xl:w-8/12 lg:w-10/12 w-10/12 xl:-mt-8 lg:-mt-8 md:-mt-8 -mt-12 bg-white text-center p-4 shadow-md z-10 text-container">
                <h3 class="text-lg font-semibold text-blue">Penelopa Miller</h3>
                <p class="text-sm text-para">CEO of Industrie</p>
              </div>
            </div>
          </div>

          <div class="group">
            <div class="image-container">
              <img
                class="xl:w-12/12 w-full zoom-effectt"
                src={abt6}
                alt="Penelopa Miller"
              />
            </div>

            <div className="flex justify-center">
              <div className="xl:w-8/12 lg:w-10/12 w-10/12 xl:-mt-8 lg:-mt-8 md:-mt-8 -mt-12 bg-white text-center p-4  shadow-md z-10 text-container">
                <h3 className="text-lg font-semibold text-blue">Peter Hase</h3>
                <p className="text-sm text-para">Sr. Engineer</p>
              </div>
            </div>
          </div>

          <div class="group">
            <div class="image-container">
              <img
                class="xl:w-12/12 w-full zoom-effectt"
                src={abt7}
                alt="Penelopa Miller"
              />
            </div>

            <div className="flex justify-center">
              <div className="xl:w-8/12 lg:w-10/12 w-10/12 xl:-mt-8 lg:-mt-8 md:-mt-8 -mt-12 bg-white text-center p-4  shadow-md z-10 text-container">
                <h3 className="text-lg font-semibold text-blue">
                  Lawrence Peter
                </h3>
                <p className="text-sm text-para">Four Man</p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <Footer />
    </section>
  );
}
